import axios from 'axios';
import {
  ProxyProvider,
  IProvider,
  NetworkConfig,
  SmartContract,
  Account,
  parseUserKey,
  UserSigner,
  SmartContractAbi,
  Code,
  GasLimit,
  AbiRegistry,
  Address,
  ContractFunction,
  BytesValue,
  Balance,
  U32Value,
  BigUIntValue,
  AddressValue,
  Transaction,
  TransactionPayload,
  QueryResponse,
  TypedValue,
  CodeMetadata,
  BooleanValue,
  List,
  ListType,
  AddressType
} from '@elrondnetwork/erdjs';
import BigNumber from 'bignumber.js';
import { useGetNetworkConfig } from '@elrondnetwork/dapp-core';

interface GetLatestTransactionsType {
  apiAddress: string;
  address: string;
  contractAddress: string;
  timeout: number;
  page?: number;
  url?: string;
}

interface GetContractFunctionType {
  apiAddress: string;
  address: string;
  contractAddress: string;
  contractFunction: string;
}

const fetchTransactions = (url: string) =>
  async function getTransactions({
    apiAddress,
    address,
    contractAddress,
    timeout
  }: GetLatestTransactionsType) {
    try {
      const { data } = await axios.get(`${apiAddress}${url}`, {
        params: {
          sender: address,
          receiver: contractAddress,
          condition: 'must',
          size: 25
        },
        timeout
      });

      return {
        data: data,
        success: data !== undefined
      };
    } catch (err) {
      return {
        success: false
      };
    }
  };

export const parseQueryResultBoolean = (queryResponse: QueryResponse) => {
  const resultBuff = Buffer.from(
    queryResponse?.returnData?.[0],
    'base64'
  ).toString('hex');
  return resultBuff === '01' ? 'true' : 'false';
};

export const parseQueryResultInt = (queryResponse: QueryResponse) => {
  const resultBuff = Buffer.from(
    queryResponse?.returnData?.[0],
    'base64'
  ).toString('hex');
  return new BigNumber(resultBuff, 16).toString(10);
};

export const parseQueryResultString = (queryResponse: QueryResponse) => {
  const resultBuff = Buffer.from(
    queryResponse?.returnData?.[0],
    'base64'
  ).toString('utf8');
  return resultBuff;
};

const fetchContractFunction = (contractFunction: string, resultType: string) =>
  async function getPrice({
    apiAddress,
    address,
    contractAddress,
    contractFunction
  }: GetContractFunctionType) {
    //getNftPrice
    try {
      const proxy = new ProxyProvider(apiAddress);
      const contract = new SmartContract({
        address: new Address(contractAddress)
      });
      const response = await contract.runQuery(proxy, {
        func: new ContractFunction(contractFunction)
      });
      //const price = parseQueryResultInt(test);
      let result = '';

      if (resultType === 'string') {
        result = parseQueryResultString(response);
      } else if (resultType === 'boolean') {
        result = parseQueryResultBoolean(response);
      } else {
        result = parseQueryResultInt(response);
      }
      return {
        data: result,
        success: result !== undefined
      };
    } catch (err) {
      return {
        data: '',
        success: false
      };
    }
  };

export const getContractData = fetchContractFunction('', 'int');
export const getContractDataBoolean = fetchContractFunction('', 'boolean');
export const getContractDataString = fetchContractFunction('', 'string');
export const getTransactions = fetchTransactions('/transactions');
export const getTransactionsCount = fetchTransactions('/transactions/count');
